module.exports = __webpack_public_path__ + "static/media/DSC_0053.a5fbfcbf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/events/DSC_0053.jpg
// module id = 588
// module chunks = 0